// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumb-title {
	font-size: 20px;
	/* border-right: 1.5px solid #aaa4a4 */
}
.breadcrumb-item{
	font-size: 20px !important;
	color: var(--color-text-dark);
}

.page-breadcrumb .breadcrumb li.breadcrumb-item {
	font-size: 16px
}

.page-breadcrumb .breadcrumb-item+.breadcrumb-item::before {
	display: inline-block;
	padding-right: .5rem;
	color: var(--color-icon-muted);
	/* font-family: LineIcons;
	content: "\\ea5c" */
}
.breadcrumb-title i {
	color:var(--color-text-dark) ;
}
.breadcrumb-title a{
	color:var(--color-text-dark);
	text-decoration: none;
}

.breadcrumb {
	margin-bottom: 0.5rem;
	margin-left:0.5rem;
}
@media (max-width: 768px) {
  .page-breadcrumb.breadcrumb-title {
    display: flex !important;
    white-space: normal !important;
    overflow: hidden;
	margin-top: 50px;
  }

  .page-breadcrumb .breadcrumb-item {
    font-size: 18px !important;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.breadcrumb-item.active {
	color: var(--color-text-dark) !important;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/Breadcrumbs.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,sCAAsC;AACvC;AACA;CACC,0BAA0B;CAC1B,6BAA6B;AAC9B;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,oBAAoB;CACpB,8BAA8B;CAC9B;mBACkB;AACnB;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,4BAA4B;CAC5B,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;AACA;EACE;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,gBAAgB;CACnB,gBAAgB;EACf;;EAEA;IACE,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;AACF;AACA;CACC,wCAAwC;AACzC","sourcesContent":[".breadcrumb-title {\n\tfont-size: 20px;\n\t/* border-right: 1.5px solid #aaa4a4 */\n}\n.breadcrumb-item{\n\tfont-size: 20px !important;\n\tcolor: var(--color-text-dark);\n}\n\n.page-breadcrumb .breadcrumb li.breadcrumb-item {\n\tfont-size: 16px\n}\n\n.page-breadcrumb .breadcrumb-item+.breadcrumb-item::before {\n\tdisplay: inline-block;\n\tpadding-right: .5rem;\n\tcolor: var(--color-icon-muted);\n\t/* font-family: LineIcons;\n\tcontent: \"\\ea5c\" */\n}\n.breadcrumb-title i {\n\tcolor:var(--color-text-dark) ;\n}\n.breadcrumb-title a{\n\tcolor:var(--color-text-dark);\n\ttext-decoration: none;\n}\n\n.breadcrumb {\n\tmargin-bottom: 0.5rem;\n\tmargin-left:0.5rem;\n}\n@media (max-width: 768px) {\n  .page-breadcrumb.breadcrumb-title {\n    display: flex !important;\n    white-space: normal !important;\n    overflow: hidden;\n\tmargin-top: 50px;\n  }\n\n  .page-breadcrumb .breadcrumb-item {\n    font-size: 18px !important;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n.breadcrumb-item.active {\n\tcolor: var(--color-text-dark) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
